document.addEventListener('DOMContentLoaded', function() {

  // Existing custom variant behavior
  $('.customm_product .disabled.customhide').prop("disabled", true);

  const customHide = document.getElementsByClassName('customhide')[0];
  if (customHide) {
    customHide.style.display = 'none';
  }

  $('.customm_product .disabled.customhide').prop("disabled", true);
  $('.customm_product .disabled.customhide').hide();

  // Existing Quick Add behavior
  $('.quick-add__submit').click(function() {
    setTimeout(function() {
      const customHide = document.querySelector('.customhide');

      if (customHide) {
        customHide.style.display = 'none';
      }
    }, 1000);
  });

});